import Ajio from "../../assets/works/Ajio.png";


export const projectsData = [
  {
    id: 1,
    image: Ajio,
    title: "AJIO",
    description:
      "AJIO, a fashion and lifestyle brand, is Reliance Retail's digital commerce initiative and is the ultimate fashion destination for styles that are handpicked, on trend and at prices that are the best you'll find anywhere.",
    tech: "React | Redux | CSS | Chakra-UI | json-server | render",
    code: "https://github.com/piyushkhurana8744/Ajio",
    demo: "https://ajio-app.vercel.app/",
    category: "react",
  },
  // {
  //   id: 2,
  //   image: ,
  //   title: "",
  //   description:
  //     "",
  //   tech: "React | Redux | CSS | Chakra-UI",
  //   code: "",
  //   demo: "",
  //   category: "react",
  // },
  // {
  //   id: 3,
  //   image: ,
  //   title: "",
  //   description:
  //     "",
  //   tech: "HTML | CSS | JavaScript",
  //   code: "",
  //   demo: "",
  //   category: "javascript",
  // },
  // {
  //   id: 4,
  //   image: ,
  //   title: "",
  //   description:
  //     "",
  //   tech: "React | Redux | NodeJS | MongoDB",
  //   code: "",
  //   demo: "",
  //   category: "mern",
  // },
  // {
  //   id: 5,
  //   image: ,
  //   title: "",
  //   description:
  //     "",
  //   tech: "React | CSS | Chakra-UI",
  //   code: "",
  //   demo: "",
  //   category: "react",
  // }
];

export const projectNav = [
  {
    name: "all",
  },
  {
    name: "mern",
  },
  {
    name: "react",
  },
  {
    name: "javascript",
  },
];